'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');

/**
 * 垂直分割条
 */
var VerticalRule = React.createClass({
    render: function () {
      var style = {backgroundColor : styleHelper.getBackgroundColor(this.props)};
      return (
        <div style={style} className="component component-VRule">
        </div>
      );
    }
});

module.exports = VerticalRule;



// WEBPACK FOOTER //
// ./src/views/Components/VRule.jsx